import React from 'react'

const The_authentication_factor = () => {
  return (
    <>
<section className="fresh-vegetable-section section-lg-space">
  <div className="container-fluid-lg" style={{ paddingLeft: '16px', paddingRight: '16px' }}>
    <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-6 col-12">
              <div className="fresh-contain p-center-left">
                <div>
<div className="review-title">
  <h2 style={{ 
    fontSize: 'clamp(20px, 5vw, 40px)',
    lineHeight: '1.3',
    fontWeight: '700',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    padding: '20px',
  }}>
    The authentication factor: An effort to put your mind at ease
  </h2>
</div>

                  <div className="delivery-list">
                    <p
                      className="text-content "
                      style={{ textAlign: 'justify', paddingRight:'20px', paddingLeft:'20px' }}
                    >
                      Amidst various protein supplements of various brands, identifying a true and
                      original product is a tough nut to crack. When you consume these fake
                      supplements, you won’t see any positive results and sometimes you might face
                      health issues. So consuming original supplements is the best. Fake supplements
                      also result in lost trust. We understand the trust you put in us and thus to
                      eliminate the chances of receiving a fake or duplicate product, we initiated a
                      product authenticity mechanism. With our every product, you get a unique
                      authentication code inside the pack which you can use to verify your purchase.
                      You can SMS the code or log in to our website and enter the code to check
                      whether the product you purchased is manufactured by us or not. This saves you
                      from duplicate products and keeps your trust intact.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-12">
              <div className="row g-sm-4 g-2">
                <div className="col-12">
                  <div className="fresh-image-2 p-5">
                    <div>
                      <img src="/assets/images/new-images/Yeast Protein Pouch combo -1.png" alt="Fresh Image" className="" width={'80%'} style={{ borderRadius: '20px', border: '1px solid #EDE7E6' }}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default The_authentication_factor
